import axios from 'axios'
import { config, options, unknownError } from '../../common/utility'
import { USER_LOGOUT, UPDATE_AUTH, UPDATE_USER_DETAILS } from '../types'

export const loginAction =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      const res = await axios({
        method: 'post',
        url: `${config.REACT_APP_GATEWAY_API_ENDPOINT}auth/v1/authentications`,
        data: JSON.stringify({
          email,
          password,
        }),
        ...options,
      })
      dispatch({
        type: UPDATE_AUTH,
        payload: { auth: res?.data, isLoggedIn: true },
      })
      return Promise.resolve(res?.data)
    } catch (err) {
      dispatch({
        type: UPDATE_AUTH,
        payload: { error: err.message || unknownError },
      })
      return Promise.reject(err.message || unknownError)
    }
  }

export const authorizeUser = () => async (dispatch, getState) => {
  try {
    const { auth } = getState().authReducer
    const res = await axios({
      method: 'post',
      url: `${config.REACT_APP_GATEWAY_API_ENDPOINT}auth/v1/authorizations`,
      data: JSON.stringify({
        token: auth?.token,
        claims: ['ALL'],
      }),
      ...options,
    })
    dispatch({
      type: UPDATE_AUTH,
      payload: { isLoggedIn: true, user: res?.data },
    })
    return Promise.resolve(res?.data)
  } catch (err) {
    dispatch({ type: USER_LOGOUT })
    return Promise.reject(err.message || unknownError)
  }
}

export const getUserDetails = () => async (dispatch, getState) => {
  try {
    const { user, auth } = getState().authReducer
    const encodedEmail = encodeURIComponent(user?.email)
    const res = await axios({
      method: 'get',
      url: `${config.REACT_APP_GATEWAY_API_ENDPOINT}user/v1/users?email=${encodedEmail}`,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${auth?.token}`,
      },
    })
    dispatch({
      type: UPDATE_USER_DETAILS,
      payload: res?.data,
    })
    return Promise.resolve(res?.data)
  } catch (err) {
    authLogout()
    return Promise.reject(err.message || unknownError)
  }
}

export const authLogout = () => (dispatch) => {
  dispatch({ type: USER_LOGOUT })
}
